/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4b465249afd05a97d3589aaf2066913393da6c51";
